<template>
  <v-card :disabled="loading" :loading="loading">
    <v-toolbar color="primary">
      <v-toolbar-title
        ><h1>{{ $t("config_round.config_round") }}</h1></v-toolbar-title
      >
    </v-toolbar>
    <v-card-text class="px-1 px-md-3 px-xl-6">
      <v-tabs v-model="level_tab">
        <v-tabs-slider color="yellow"></v-tabs-slider>
        <v-tab
          v-for="(level, i) in levels"
          :key="i"
          @click="configRound_yearID = null"
        >
          <h2>
            {{ objectTranslator(level, "LEVEL_NAME") }}
          </h2>
        </v-tab>
      </v-tabs>

      <v-window v-model="level_tab" touchless>
        <v-window-item v-for="(level, i) in levels" :key="i">
          <v-card>
            <v-card-text class="px-1 px-md-3 px-xl-6">
              <v-autocomplete
                v-model="configRound_yearID"
                v-bind:label="$t('config_round.config_year')"
                v-bind:items="
                  listFilter(config_years, level.LEVEL_ID, 'LEVEL_ID')
                "
                v-bind:item-value="(item) => item.YEAR_ID"
                v-bind:item-title="
                  (item) => item.ADMIT_SEMESTER + ' / ' + item.ADMIT_YEAR
                "
                outlined
              ></v-autocomplete>

              <div v-show="configRound_yearID">
                <v-divider></v-divider>
                <v-btn
                  color="success"
                  @click="
                    $refs.addEditDialog.open_add_modal(configRound_yearID)
                  "
                  class="mt-3"
                >
                  <v-icon>mdi-plus</v-icon>{{ $t("config.addnew") }}
                </v-btn>

                <v-table
                  min-height="300px"
                  class="mt-3 text-no-wrap text-center primary"
                >
                  <thead class="thead-config">
                    <tr>
                      <th class="text-center">
                        {{ $t("config.edit") }}
                      </th>
                      <th class="text-center">
                        {{ $t("config.delete") }}
                      </th>
                      <th class="text-center">#</th>
                      <th class="text-center">
                        {{ $t("config_year.admit_semester") }} /
                        {{ $t("config_year.admit_year") }}
                      </th>
                      <th class="text-center">
                        {{ $t("config_round.round_name_th") }}
                      </th>
                      <th class="text-center">
                        {{ $t("config_round.round_name_en") }}
                      </th>
                      <th class="text-center">
                        {{ $t("config_round.round_start_datetime") }}
                      </th>
                      <th class="text-center">
                        {{ $t("config_round.round_end_datetime") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(round, index) in rounds"
                      v-bind:key="round.ROUND_ID"
                    >
                      <td>
                        <v-btn
                          small
                          color="warning"
                          v-on:click="
                            $refs.addEditDialog.open_edit_modal(round)
                          "
                        >
                          <v-icon>mdi-pencil</v-icon>{{ $t("config.edit") }}
                        </v-btn>
                      </td>
                      <td>
                        <v-btn
                          small
                          color="error"
                          @click="open_delete_modal(round)"
                        >
                          <v-icon>mdi-delete</v-icon>{{ $t("config.delete") }}
                        </v-btn>
                      </td>
                      <td>{{ index + 1 }}</td>
                      <td>
                        {{ years[0].ADMIT_SEMESTER }}/{{ years[0].ADMIT_YEAR }}
                      </td>
                      <td>{{ round.ROUND_NAME_TH }}</td>
                      <td>{{ round.ROUND_NAME_EN }}</td>
                      <td
                        class="font-weight-bold"
                        v-html="dt(round.START_DATETIME, true)"
                      ></td>
                      <td
                        class="font-weight-bold"
                        v-html="dt(round.END_DATETIME, true)"
                      ></td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </v-card-text>
          </v-card>
        </v-window-item>
      </v-window>
    </v-card-text>
    <ConfigRoundAddEditDialog
      ref="addEditDialog"
      :toggle_loading="toggle_loading"
    />

    <ConfigRoundDeleteDialog
      v-model="showing_delete_modal"
      :title="$t('config_round.config_round')"
      :text="
        to_delete_round_item
          ? ' รอบ ' +
            objectTranslator(to_delete_round_item, 'ROUND_NAME') +
            ' ( ปีการศึกษา ' +
            this.to_delete_year +
            ') ' +
            ' - ' +
            to_delete_round_item.ROUND_ID
          : ''
      "
      :deleteFunction="delete_config_round"
    />
  </v-card>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import ConfigRoundAddEditDialog from "./components/ConfigRoundAddEditDialog";
import ConfigRoundDeleteDialog from "./components/ConfigRoundDeleteDialog";
import {
  objectTranslator,
  dateTimeFromDBTranslatorFull as dt,
} from "@/helper/translator";
// import { getYearsModified } from "@/helper/dateTime";
import { listFilter, getById } from "@/helper/filter";
import ConfigProvider from "@/services/config.provider";

const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

export default {
  name: "ConfigRound",

  data: () => ({
    loading: false,
    level_tab: 0,
    showing_delete_modal: false,
    to_delete_round_id: null,
    to_delete_year_id: null,
    to_delete_year: null,
    to_delete_round_item: null,
    configRound_yearID: null,
    levels: [
      {
        LEVEL_ID: "1",
        LEVEL_NAME_EN: "Undergraduate",
        LEVEL_NAME_TH: "ปริญญาตรี",
      },
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "Graduate (4+1, Master, Doctor)",
        LEVEL_NAME_TH: "บัณฑิตศึกษา (4+1, โท, เอก)",
      },
    ],
  }),

  components: {
    ConfigRoundAddEditDialog,
    ConfigRoundDeleteDialog,
  },

  computed: {
    ...mapOfficerConfigFields({
      config_years: "config_years",
      config_rounds: "config_rounds",
    }),

    rounds() {
      // console.log(this.configRound_yearID);
      let data = null;
      if (this.configRound_yearID != null) {
        data = listFilter(
          this.config_rounds,
          this.configRound_yearID,
          "YEAR_ID"
        );
      }
      return data;
    },
    years() {
      let data = null;
      if (this.configRound_yearID != null) {
        data = listFilter(
          this.config_years,
          this.configRound_yearID,
          "YEAR_ID"
        );
      }
      return data;
    },
  },

  methods: {
    dt,
    getById,
    listFilter,
    objectTranslator,

    toggle_loading(status) {
      this.loading = status;
    },

    open_delete_modal(item) {
      this.to_delete_round_id = item.ROUND_ID;
      this.to_delete_year_id = item.YEAR_ID;
      this.to_delete_year =
        this.years[0].ADMIT_YEAR + " / " + this.years[0].ADMIT_SEMESTER;
      this.to_delete_round_item = item;
      this.showing_delete_modal = true;
    },

    async delete_config_round() {
      this.loading = true;

      let response = await configService
        .deleteRound({
          id: this.to_delete_round_id,
        })
        .catch((error) => {
          this.$toast.error(JSON.stringify(error.response.data.message));
          this.toggle_loading(false);
        });
      this.$store.dispatch("officerConfig/getYears");
      this.$store.dispatch("officerConfig/getRounds");
      if (response && response.status)
        this.$toast.success(this.$t("toast.delete_successfully"));
      else this.$toast.error(this.$t("toast.cannot_delete"));

      this.toggle_loading(false);

      this.showing_delete_modal = false;
      this.loading = false;
    },
  },
  created() {
    // this.init_data();
    this.$store.dispatch("officerConfig/getYears");
    this.$store.dispatch("officerConfig/getRounds");
  },
};
</script>

<!-- <style>
th {
  letter-spacing: 1px;
}
</style> -->
